import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DirCategory } from '../services/myDriveService';

interface Props {
  category: DirCategory;
  prefix: string;                 // e.g. "docs/2026/"
  onNavigate: (p: string) => void;
}

const CAT_LABEL_KEYS: Record<DirCategory, string> = {
  system:   'myDrive.catSystem',
  mail:     'myDrive.catMail',
  photos:   'myDrive.catPhotos',
  personal: 'myDrive.catPersonal',
};

export default function AddressBar({ category, prefix, onNavigate }: Props) {
  const { t } = useTranslation();

  const parts = prefix ? prefix.replace(/\/$/, '').split('/') : [];

  return (
    <Box sx={{ px: 2, py: 0.5, borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
      <Breadcrumbs separator="›">
        <Link component="button" variant="body2" underline="hover"
              onClick={() => onNavigate('')}>
          {t(CAT_LABEL_KEYS[category], category)}
        </Link>
        {parts.map((part, idx) => {
          const path = parts.slice(0, idx + 1).join('/') + '/';
          const isLast = idx === parts.length - 1;
          return isLast ? (
            <Typography key={path} variant="body2">{part}</Typography>
          ) : (
            <Link key={path} component="button" variant="body2" underline="hover"
                  onClick={() => onNavigate(path)}>
              {part}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
}
